import React from 'react'
import PropTypes from 'prop-types'
import FieldTitle from '../../../../molecules/FieldTitle'
import AttentionHours from '../../../office_hours/AttentionHours'
import useUserPermission from '../../../../../hooks/useUserPermission'
import useFieldValue from '../../../../../hooks/useFieldValue'
import OfficeHourAlert from './OfficeHourAlert'
import { OfficeHourHintOtherForm, OfficeHourHintReceptionDesk } from './OfficeHourHint'
import FieldCheckboxTitle from '../../../../molecules/FieldCheckboxTitle'
import clsx from 'clsx'
import { useField } from 'react-final-form'

const getHint = (canChangeOfficeHour, isReceptionDesk, additionalConfig) => {
  return isReceptionDesk ? (
    <OfficeHourHintReceptionDesk additionalConfig={additionalConfig} canChangeOfficeHour={canChangeOfficeHour} />
  ) : (
    <OfficeHourHintOtherForm additionalConfig={additionalConfig} canChangeOfficeHour={canChangeOfficeHour} />
  )
}

const getTitle = (isReceptionDesk, additionalConfig) => {
  let title = 'Horario de atención del formulario'
  if (isReceptionDesk) title = 'Horario de atención de la Mesa de partes'

  if (additionalConfig === 'suggested_required') title += ' (obligatorio)'
  if (additionalConfig === 'suggested') title += ' (opcional)'
  return `${title}:`
}

const OfficeHour = ({ config }) => {
  const { canChangeOfficeHour } = useUserPermission('officeHour')
  const { input: startOfficeHour } = useField('start_office_hour')
  const { input: endOfficeHour } = useField('end_office_hour')
  const hasOfficeHour = useFieldValue('has_office_hour')
  const isReceptionDesk = config.reception_desk
  const additionalConfig = config.additional_config
  const hint = getHint(canChangeOfficeHour, isReceptionDesk, additionalConfig)
  const initialEndHourProps = isReceptionDesk
    ? { initialStartHour: '6:00', initialEndHour: '15:00', minRangeDifference: 8 }
    : {}
  const isRequired = ['required', 'suggested_required'].includes(additionalConfig)
  const title = getTitle(isReceptionDesk, additionalConfig)

  const handleResetOfficeHour = value => {
    startOfficeHour.onChange(value ? config.start_office_hour : null)
    endOfficeHour.onChange(value ? config.end_office_hour : null)
  }

  return (
    <>
      {additionalConfig === 'suggested' ? (
        <FieldCheckboxTitle
          name={'has_office_hour'}
          label={title}
          description={hint}
          onChange={handleResetOfficeHour}
        />
      ) : (
        <FieldTitle title={title} hint={hint} />
      )}
      {(['required', 'suggested_required'].includes(additionalConfig) || hasOfficeHour) && (
        <div className={clsx('flex w-full mt-6', hasOfficeHour && 'ml-7')}>
          <div className="md:w-2/5">
            {additionalConfig === 'required' ? (
              <>
                <div className="mb-4">
                  <FieldTitle title="Hora de inicio de atención:" hint={startOfficeHour.value} />
                </div>
                <div>
                  <FieldTitle title="Hora de fin de atención:" hint={endOfficeHour.value} />
                </div>
              </>
            ) : (
              <>
                <AttentionHours
                  enabled
                  startName="start_office_hour"
                  endName="end_office_hour"
                  required={isRequired}
                  {...initialEndHourProps}
                />
              </>
            )}
          </div>
          <OfficeHourAlert isReceptionDesk={config.reception_desk} />
        </div>
      )}
    </>
  )
}

export default OfficeHour

OfficeHour.propTypes = {
  config: PropTypes.object
}
